RegExp.prototype.tryTest = function (value) {
	try {
		return this.test(value);
	} catch (e) {
		return false;
	}
};

export {};
